import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import * as React from 'react';

import { Tab, TabList, Tabs, TabsSize } from '../../components/Tabs/Tabs';
import { Bem } from '../../service/Bem/Bem';
import { Page } from '../common/typings';

import './PageToolbar.css';
import * as keyset from './PageToolbar.i18n';

const i18n = i18nFactory(keyset);

interface PageToolbarProps {
    className?: string;
    pages: Page[];
    activeTab: Page;
    isCreate?: boolean;
    changePage: (page: Page) => void;
}

const BLOCK = 'page-toolbar';

export class PageToolbar extends React.Component<PageToolbarProps> {
    render(): JSX.Element {
        const { className } = this.props;

        return (
            <div className={classNames(BLOCK, className)}>
                {this.getTitle()}
                {this.renderTabs(this.props.pages)}
            </div>
        );
    }

    private renderTabs = (pages: Page[]): React.ReactNode => {
        return (
            <Tabs
                size={TabsSize.m}
                selectedIndex={pages.findIndex(item => item === this.props.activeTab)}
                onSelect={this.onTabSelect}
            >
                <TabList>
                    {pages.map(page => (
                        <Tab key={page}>{this.getPageTitle(page)}</Tab>
                    ))}
                </TabList>
            </Tabs>
        );
    };

    private onTabSelect = (index: number) => {
        this.props.changePage(this.props.pages[index]);
    };

    private getTitle(): JSX.Element {
        return <div className={Bem.cls(BLOCK, 'title')}>{i18n('title')}</div>;
    }

    private getPageTitle(page: Page, isCreate?: boolean): string {
        switch (page) {
            case Page.PRESETS:
                return i18n(isCreate ? 'create-on-preset' : 'presets');

            case Page.CREATIVES:
                return i18n('creatives');

            case Page.IDEAS:
                return i18n('ideas');

            default:
                return '';
        }
    }
}
